import React from 'react';
import { t } from 'i18next';
import { UseFormSetValue } from 'react-hook-form';

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import { PaxResponseDto } from '@bandido/shared/dtos';
import { fromYYYYMMDDToDDMMYYYY, getExactAgeForDOB } from '@frontend/features/common/helper';

import { Form } from './form';

interface Props {
  setValue: UseFormSetValue<Form>;
  cartPaxes: PaxResponseDto[];
  occupancyIndex: number;
  paxIndex: number;
  checkinDate?: string;
}

export const CartPaxes: React.FC<Props> = ({ occupancyIndex, paxIndex, cartPaxes, setValue, checkinDate }) => (
  <FormControl>
    <InputLabel >{t('hotels.fares.hotelPaxData.pax.useExisting')}</InputLabel>
    <Select
      size="small"
      onChange={(event) => {
        const selectedPax = cartPaxes?.find(pax => pax.id === event.target.value);
        if (selectedPax) {
          setValue(`occupancies.${occupancyIndex}.paxes.${paxIndex}.id`, selectedPax.id, { shouldValidate: true });
          setValue(`occupancies.${occupancyIndex}.paxes.${paxIndex}.name`, selectedPax.name, { shouldValidate: true });
          setValue(`occupancies.${occupancyIndex}.paxes.${paxIndex}.surname`, selectedPax.lastName, { shouldValidate: true });
          setValue(
            `occupancies.${occupancyIndex}.paxes.${paxIndex}.dob`,
            fromYYYYMMDDToDDMMYYYY(selectedPax.dob), 
            { shouldValidate: true }
          );
          setValue(
            `occupancies.${occupancyIndex}.paxes.${paxIndex}.age`,
            getExactAgeForDOB(selectedPax.dob, checkinDate),
            { shouldValidate: true }
          );
        }
      }}
    >
      {cartPaxes.map((pax) => (
        <MenuItem key={pax.id} value={pax.id}>
          {pax.name} {pax.lastName}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
